<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="flex">
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="企业名称" prop="name">
            <el-select
              v-model="table.params.name"
              filterable
              clearable
              placeholder="请选择"
              @change="handleSearch"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        indexLabel="序号"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:num="{ row }">
          <el-button type="text" size="mini" @click="showDetails(row)"
            >{{ row.num }}人</el-button
          >
        </template>
      </VTable>
    </div>

    <detail ref="detail" @refresh="getTable"></detail>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import detail from "./components/detail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportList",
  mixins: [mixinTable],
  components: {
    VTable,
    detail,
  },
  data() {
    return {
      field: [
        { name: "name", label: "企业名称", hidden: false },
        { name: "legal_name", label: "联系人", hidden: false },
        { name: "phone", label: "联系电话", hidden: false },
        { name: "earnest_amount", label: "累计缴纳金额", hidden: false },
        {
          name: "use_earnest",
          label: "保证金余额",
          width: "160",
          hidden: false,
        },
        {
          name: "take_earnest",
          label: "保证金扣款",
          width: "160",
          hidden: false,
        },
        { name: "num", label: "入职人数", width: "160", hidden: false },
        { name: "change_time", label: "更新时间", width: "160", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          name: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      companyList: [],
    };
  },
  created() {
    this.getTable();
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      this.$http
        .get("admin/company/list", {
          params: { page: 1, count: 10000, type: 2 },
        })
        .then((res) => {
          if (res.code === 1) {
            this.companyList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getTable() {
      this.$http
        .get("/admin/earnest/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    // 创建、编辑
    showDetails(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>